import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DataTable from "../components/UI/DataTable/DataTable";
import { OCCUPIED_TABLE_COLUMNS } from "../constants/Constants";
import { TABLES } from "../enums/Enums";
import store from "../redux/Store";
import { allocationsActions } from "../redux/reducers/AllocationsReducer";
import { refreshAllUsersData } from "../services/ParkerService";

const useAllocationService = () => {
  const currentUsersScopes = useSelector(
    (state) => state.user.currentUsersScopes
  );
  const parkers = useSelector((state) => state.user.parkers);
  const selectedScope = useSelector((state) => state.user?.selectedScope);

  const isFirstTimeLoading = useSelector(
    (state) => state.common.isFirstTimeLoading
  );
  const sites = useSelector((state) => state.user.sites);
  const userTypes = useSelector((state) => state.user?.initialState?.userTypes);

  let allocations = useSelector((state) => state.allocations.allocations);

  useEffect(() => {
    // when parker data arrives after the call, arranges the allocations data  
    if (parkers) {
      store.dispatch(allocationsActions.setAllocations({parkers, sites, userTypes}));
    }
  }, [parkers]);

  //Set all tables data
  useEffect(() => {
    if (selectedScope) {
      refreshAllUsersData(null, currentUsersScopes, null, null, true);    
    }
  }, [sites, currentUsersScopes, selectedScope]);

  const getOccupiedDataTable = (eventFn) => {
    return (
      selectedScope && (
        <DataTable
          onRowClick={eventFn.bind(this, TABLES.OCCUPIED)}
          columns={OCCUPIED_TABLE_COLUMNS}
          rows={allocations}
          tableId={TABLES.OCCUPIED}
          selectedScope={selectedScope}
        ></DataTable>
      )
    );
  };

  return {
    getOccupiedDataTable,
  };
};

export default useAllocationService;
